"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModalConfirmationState = void 0;
var _noop = _interopRequireDefault(require("lodash/noop"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const reducer = (prevState, action) => {
  switch (action.type) {
    case "OPEN_MODAL":
      return {
        show: true,
        onConfirm: () => action.payload.resolve(true),
        onClose: () => action.payload.resolve(false)
      };
    case "CLOSE_MODAL":
      return {
        show: false,
        onConfirm: _noop.default,
        onClose: _noop.default
      };
    default:
      return prevState;
  }
};
const useModalConfirmationState = () => {
  const [state, dispatch] = (0, _react.useReducer)(reducer, {
    show: false,
    onConfirm: _noop.default,
    onClose: _noop.default
  });
  const waitForConfirmation = (0, _react.useCallback)(() => new Promise(resolve => {
    dispatch({
      type: "OPEN_MODAL",
      payload: {
        resolve
      }
    });
  }), [dispatch]);
  const onConfirm = (0, _react.useCallback)(() => {
    state.onConfirm();
    dispatch({
      type: "CLOSE_MODAL"
    });
  }, [state, dispatch]);
  const onClose = (0, _react.useCallback)(() => {
    state.onClose();
    dispatch({
      type: "CLOSE_MODAL"
    });
  }, [state, dispatch]);
  return {
    show: state.show,
    /**
     * opens the confirmation modal and returns a promise to its result once it closes.
     */
    waitForConfirmation,
    onConfirm,
    onClose
  };
};
exports.useModalConfirmationState = useModalConfirmationState;
//# sourceMappingURL=useModalConfirmationState.js.map